// EXAM FRONTEND — Staging-2026 Environment Configuration
// Configuration de l'environnement Staging-2026 pour le frontend Examens
//
// API domains (managed via CDK ExamsBackendStack + Route53Stack in PRO account):
//   Exam backend:  exams.api.stage.tsin.ca  → UCAN ALB (816373663626)
//   Auth service:  auth.api.stage.tsin.ca   → PRO account ALB (339713160237)
//   WWUS service:  wwus.api.stage.tsin.ca   → PRO account ALB
//   Payment API:   payment.api.stage.tsin.ca → TSIN account ALB (483382415631)
//   AuthUI login:  auth.stage.tsin.ca       → PRO account CloudFront
//   Payment UI:    payment.stage.tsin.ca    → TSIN account CloudFront
export const environment = {
  production: false,

  // ── Exam backend (UCAN account — ECS Fargate / ALB) ──────────────────────────
  // Backend Examens (compte UCAN — ECS Fargate / ALB)
  apiUrl:       'https://exams.api.stage.tsin.ca/api',
  testUrl:      'https://exams.api.stage.tsin.ca/api',

  // ── Auth & user management (PRO account — existing staging services) ──────────
  // Auth et gestion des utilisateurs (compte PRO — services staging existants)
  authBaseUrl:  'https://auth.api.stage.tsin.ca/api',
  userBaseUrl:  'https://pro.api.stage.tsin.ca/api',
  // Base URL for the auth-UI login page. The validate-token component appends
  // ?returnTo=<current-origin>/account/validate-token so auth-UI redirects back
  // after a successful Cognito login.
  // URL de base de la page de connexion auth-UI. Le composant validate-token ajoute
  // ?returnTo=<origine>/account/validate-token pour que auth-UI redirige après connexion.
  userMgtUrl:   'https://auth.stage.tsin.ca/login',

  // ── WWUS service (PRO account) ────────────────────────────────────────────────
  // Service WWUS (compte PRO)
  wwuBaseUrl:   'https://wwus.api.stage.tsin.ca/api',

  // ── Payment service (TSIN account) ───────────────────────────────────────────
  // Service paiement (compte TSIN)
  paymentUrl:    'https://payment.stage.tsin.ca',
  paymentApiUrl: 'https://payment.api.stage.tsin.ca/api',

  // ── Learning service (Learning account) ──────────────────────────────────────
  // Service d'apprentissage (compte Learning)
  learningBaseUrl: 'https://learning.api.stage.tsin.ca/api',

  // ── Encryption salt (keep consistent across environments) ─────────────────────
  // Sel de chiffrement (maintenir cohérent entre les environnements)
  salt: 'ZC\f?.Kp[jnhXf3-"<f3{/tZS@#~(8on',

  // Legacy / unused fields kept for type-compatibility
  // Champs hérités / non utilisés conservés pour la compatibilité de type
  apiUrlDemo: '',
};
